var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpster12M3Lv12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "73 188 693 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Roll_Of_Dumpster_12m3_LV12_svg__st0{fill:currentColor}.Roll_Of_Dumpster_12m3_LV12_svg__st1{opacity:.4;fill:#1d1d1b;enable-background:new}.Roll_Of_Dumpster_12m3_LV12_svg__st2{fill:#1d1d1b;enable-background:new;opacity:.1}.Roll_Of_Dumpster_12m3_LV12_svg__st3{opacity:.3}.Roll_Of_Dumpster_12m3_LV12_svg__st5{opacity:.3;fill:#040506;enable-background:new}.Roll_Of_Dumpster_12m3_LV12_svg__st7{fill:#040506;enable-background:new}.Roll_Of_Dumpster_12m3_LV12_svg__st8{enable-background:new}.Roll_Of_Dumpster_12m3_LV12_svg__st7{opacity:.8}.Roll_Of_Dumpster_12m3_LV12_svg__st8{opacity:.1;fill:#fff}.Roll_Of_Dumpster_12m3_LV12_svg__st10{opacity:.3;fill:#010101}.Roll_Of_Dumpster_12m3_LV12_svg__st12{opacity:.2;fill:#fff;enable-background:new}.Roll_Of_Dumpster_12m3_LV12_svg__st17,.Roll_Of_Dumpster_12m3_LV12_svg__st18{fill:#030405}.Roll_Of_Dumpster_12m3_LV12_svg__st18{opacity:.2}.Roll_Of_Dumpster_12m3_LV12_svg__st31{opacity:.3;fill:#040506}.Roll_Of_Dumpster_12m3_LV12_svg__st32{fill:#040506;opacity:.5;enable-background:new}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 361 187"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 361,
    height: 187,
    href: ""
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: "100%",
    height: "100%",
    viewBox: "0 0 74 103"
  }, /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 103,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Container_6_00000135666332962559774360000006183664503720639421_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Bakgrund_\\xC4ndra_F\\xE4rg_00000006676721892272476790000002105039088478446980_",
    d: "m74.8 317.7.5-94.5-1.1-.2.1-11.8 207.1-23.1 351.4 49.1 121.5-24.4 11.4 1.7.3 53.4-4.8.9-5.5-.9.2 73.4-22 57.8-26.2 9.2v18.4l-5.3 3.2-10.4 3.9-31.3-8.6-14 5.2v19l-7.8 4.8L628 458l-31.9-9.5-15.3 5.5-76.4-23.9-34.9 11.5-13.5-4.1.2-22.5-21.1-6.4-36 11-12.4-4.1.2-21.8-14.5-4.6-38.3 10.2-10.8-3.6-.2-22.3-8.5-2.5-38.8 9.9-10.8-3.2.2-22.3-3.7-.9-40.2 9.4-9.4-3V339l-40.2 8.7-9.2-2.8v-19l-37.4 7.3-8.3-2.3v-22l-1.8-.2-28 5.5v5l-4.6.7-7.6-2.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_60_x25__00000122694361710585315800000004400649791520018568_",
    d: "m280.1 190.7-.6 54L96 211.3l184.1-20.6z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_12m3_LV12_LogoA",
    transform: "translate(74.07,181.52)",
    d: "m51.248 102.02h216.96v54.121h-216.96z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_12m3_LV12_LogoB",
    transform: "translate(74.07,181.52)",
    d: "m463.62 136.98h54.6v42.148h-54.6z",
    fill: "url(#pattern-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_30_x25__00000179607572178147023210000014314637716480129669_",
    transform: "translate(313.07 47.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25236_00000155834011755703728640000002939169383205835155_",
    d: "m347.6 377.5 27.2-9.8-.1 17-27.1-7.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25241_00000036212887508885203830000018039442911366128270_",
    d: "m314.9 410.3 7.5-4.9 11.2-3.7-7.8 4.8-10.9 3.8z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25242_00000037669295186830439420000001393141674978127531_",
    d: "m378.9 386.1 5.6-3.8 10.1-3.3-5.3 3.2-10.4 3.9z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_30-80_x25__00000093855659548960086610000002229189013772387491_",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st3",
    transform: "translate(7.487 50.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25243_00000102510745971091218860000006462550288379111301_",
    d: "m467.1 334.1 77.5 21.9 28.7 47-76.4-23.9-29.8-45z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25244_00000133515123748117498230000005500200630728464265_",
    d: "m396.6 314.6 51.7 14.5.4 34.9-21.1-6.4-31-43z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25245_00000047742719382987161620000004801354974638287549_",
    d: "m332.2 296.9 32.7 41.2 14.2 4.5-.1-32.6-46.8-13.1z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25246_00000074413399163106801640000002972407801139242923_",
    d: "m273.2 280.5 42.6 12.2-.2 29.7-8.5-2.5-33.9-39.4z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25247_00000137855098039621244650000010517782186330344088_",
    d: "m257.8 304.3-.1-28-38.8-10.8 35.2 37.9 3.7.9z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25248_00000017483016074360102400000015186883470990207122_",
    d: "M204.5 288v-26.6l-35.6-9.6 35.6 36.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25249_00000039839530998022201760000003400091196189309846_",
    d: "m155.2 269.2-.3-21.2-32.1-9 32.4 30.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25250_00000085231358053512468780000005930637887210885802_",
    d: "m107.7 257.7 1.8.2-.1-22.6-29.6-8.3 27.9 30.7z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Highlight_10_x25__00000091709545166459845910000014530513461465969800_",
    d: "m564.2 255.5-11.9-2.2-.2 45.6-478-87.8-.1 11.8 1.1.2-.6 94.5 7.9 2.1-.1-95.1 34.5 7-.1 99.2 8.3 2.3V233l36.7 7.4.7 82v22.4l9.2 2.8.1-105.3 10.2 1.9-8.2 16.8v4.3l10.8-20.6 27.2 5 .1 111 9.4 3 .2-111.8 43.8 8.3-.2 117.2 10.8 3.2-.2-118.1 47.8 9.2-.1 123.8 10.8 3.6.7-125.2 36.8 7.1 14.7 29.1.3 105.2 12.4 4.1-.2-133.1 56.8 11.3.3 139.8 13.5 4.1V300l94.8 18.1v-62.6zm-188.5 26 10.5 2.2.1 18-10.6-20.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_30_x25_",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m564.2 255.5.1 62.6 5.3-2.7.2-54.8 191.4-41.5 4.4-4.7-201.4 41.1zm197 13.1 4.7-.9-.3-53.3-4.4 4.7z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st17"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Highlight_20_x25__00000173848259258000578360000007778769464984557477_",
    d: "m754.2 212.7 11.4 1.7-201.4 41.1-11.9-2.2 201.9-40.6z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_40_x25__00000016757378888137267310000000482106173670493373_",
    d: "m280.1 190.7-.6 54 272.4 49.6.5-41 69.6-14-341.9-48.6z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_50_x25_",
    d: "M761.2 219.1v49.5l-5.5-.9.1-42.3 5.4-6.3z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_30_x25__00000093856317881630707790000008263261711201522865_",
    transform: "translate(4.761 20.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25260_00000159427590514090900710000003771700475122271396_",
    d: "m371 260.8 10.6 20.3v-4.3l-8.1-15.6-2.5-.4z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25261_00000177471413895140612180000018028689103685017505_",
    d: "m464.7 279.3 5.5 1.1-.4 83.8 29.8 45-34.9 11.5V279.3z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25262_00000108994607237219119710000009249185616897464211_",
    d: "m394 265.6 4.8 1 .5 78.2 31 42.9-36 11-.3-133.1z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25263_00000177444722939546316260000008262143454399561089_",
    d: "m330 253.2 4.3.8.7 73 32.7 41.2-38.3 10.2.6-125.2z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25264_00000113327460642121711220000017277560453005386403_",
    d: "m270.9 241.8 4.2.8.9 68 33.8 39.4-38.8 9.9-.1-118.1z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25265_00000067214428202697638550000004074410585091411336_",
    d: "m216.8 231.2 4.3.8.5 63.7 35.2 37.9-40.2 9.4.2-111.8z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25266_00000112599888314370103180000010369792775329032610_",
    d: "m167.1 326.9 40.2-8.7-35.6-36.2v-37.2l10.4-20.5-2.1-.3-10.8 20.6v-4.3l2.5-5.1.2-12.8-4.6-.9-.2 105.4z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25267_00000097483772158126585700000000189975062107343789_",
    d: "m120.5 212.3 4.9 1v55.9l32.5 30.2v5.7l-37.4 7.3V212.3z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Path_25268_00000052069671432737722500000007650442953058835861_",
    d: "m77.7 204 4.7 1.1.2 52.2 27.8 30.6-28 5.5v5l-4.6.7-.1-95.1z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_20_x25__00000124857049830493799350000007386681930446786230_",
    d: "m677 283.7.8 1.2.5 1 1 .9c3.6 1.9 4.3-1.2 4.6-2.5.2-1.2-.7-4-1.3-5.3-.5-1.3-3.3-3.6-3.3-3.6l-2.6-1.7v-1.2l8.2 1.5v25.2l-4.6 7.8v10l1-.3v-1.9l6.8-1.7v-5.3l9.4 2.1v120l-5.5 3.7.2.1 10.1-3.9 5.3-3.2v-18.4l26.2-9.2 22.1-57.8-.2-73.4.1-42.3 5.4-6.3-191.4 41.4-.2 54.8-5.3 2.7-12-1.7-.2 90.3 28.7 47 15.3-5.8-.3.1 28-9.7-.5-117.9 1-66.5 3.7-.8-.1 64.1 11.4-20.6v-2.8l7.5-14.1 1.1-.5 5.4 1 3.2.6-1 .6-19.8 38.1-.1 133.3-7.2 4.8 10.4-3.6 7.8-4.8v-19l14.3-5.1 26.8 7.2.1-17 3.9-1.6V406l-45 15.8.1-4.5 41.4-14.6v-77.3l1.1-.3 2.4-3.5v-7.7L647 326.5v-1.8l1.9-.6 3.6.8 1-.3v-1.7l23.5-6.6v-32.6m10.8-7.8.5-35.9 4.1-.8v42.1l-4.6-5.4z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_30_x25__00000071525446007911777440000012087683297867678375_",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m702.8 293.8-10.2-12.2-.5-.6-4.2-5-1.9-2.3-1 .3v25.1l1-.2 11.5 10.9v120.1l10.1-3.4V299.6z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.4 316.7-.3-10.9-.7 1.1v9.9l-27 7.7-.3-12.7 2.5-4.7 1-.3v-18.2c3.8-4.3 9.3-8.2 14.4-8.1 2.9.1 5.5 1.8 6.9 4.3.5 1.2 1.3 2 2.8 2.5 1.7.3 3.1-1 3.3-3.1 0 0 .7-6.8-7.3-10.5-1.4-.6-2.9-1.1-4.4-1.4-6.2-1.3-13.7 2.9-18.8 8l3.2.6-1 .6-5.8 11-14.2 26.9v133.4l11.2-3.7V324.2l1.9-3.7 3-5.7.3-.5.5 10.7-5.7 1.6v7.6l44.9-12.9V314l-10.4 2.7zm-53.4.5 11.3-20.6.4-46.1-11.6 2.6zm72.5-79.8-8.1 1.8v42.2l7.9 9.5z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st10"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Skugga_20_x25__00000039821870704706968200000016515995999592169120_",
    d: "m761.2 219.1-5.4 6.3-186.1 40.3.1-5.1z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_12m3_LV12_svg__Highlight_20_x25__00000099639415856623594150000001532303769395999634_",
    d: "m622 239.3 10.7-2.2-351.4-49-207.1 23 478 87.8-.3-4.6-455.9-83 184.1-20.6z",
    className: "Roll_Of_Dumpster_12m3_LV12_svg__st12"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpster12M3Lv12);
export default __webpack_public_path__ + "static/media/Roll_Of_Dumpster_12m3_LV12.9cf45ff4e7ea5e2c24a6703954008798.svg";
export { ForwardRef as ReactComponent };